import React from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper-bundle.css"

import styles from "./swiperSlider.module.scss"

const SwiperSlider = ({ data }) => {
  const slides = []
  const images = data.nodes[0].images

  images.forEach((item, i) => {
    slides.push(
      <SwiperSlide key={i}>
        <img className={styles.image} src={`${item.url}`} alt={i} />
      </SwiperSlide>
    )
  })

  return (
    <div>
      <Swiper
        loop={true}
        id={styles.container}
        spaceBetween={0}
        slidesPerView={1}
      >
        {slides}
      </Swiper>
    </div>
  )
}

export default SwiperSlider
